import React from 'react'
import {Trans} from 'react-i18next'

import {Box} from '@mui/material'
import {PGTypography} from '@progynyglobal/pg-ui-library'
import {t} from 'i18next'

import ConsultationRow from '@progyny/pages/Consultations/components/ConsultationRow'

export interface SessionItem {
  sessionIndex: string
  title: string
  subtitle: string
  description: string
  language?: string
  status: string
  appointment: any
  required: boolean
}

/** Minimal shape for past appointment (query may return a subset of AppointmentType) */
export interface PastAppointmentItem {
  scheduledTime?: string | null
  bookingLanguage: string
  programEnrollment?: {
    program?: {
      sessions?: Array<{title?: string | null} | null> | null
      description?: string | null
    } | null
  } | null
  [key: string]: unknown
}

export interface PastSessionsProps {
  appointments?: PastAppointmentItem[] | null
  sessions?: SessionItem[]
  colors?: any
  className?: string
}

const PastSessions: React.FC<PastSessionsProps> = ({
  sessions,
  appointments,
  colors,
  className,
}) => {
  if (sessions?.length === 0) {
    return (
      <Box className={className}>
        <PGTypography>
          <Trans i18nKey='consultations_program_past_sessions_no_past_sessions' />
        </PGTypography>
      </Box>
    )
  }

  return (
    <Box className={className}>
      {sessions?.length &&
        sessions.map((session, index) => (
          <ConsultationRow
            key={index}
            status='completed'
            sessionLabel={`${t('common_session')} ${session.sessionIndex}`}
            title={session.title}
            colors={colors}
            scheduledTime={session.appointment?.scheduledTime}
            language={session.appointment?.bookingLanguage}
          />
        ))}

      {appointments?.length &&
        appointments.map((appointment, index) => (
          <ConsultationRow
            key={index}
            status='completed'
            title={
              appointment.programEnrollment?.program?.sessions?.[0]?.title ??
              undefined
            }
            colors={colors}
            scheduledTime={appointment.scheduledTime}
            language={appointment.bookingLanguage}
          />
        ))}
    </Box>
  )
}

export default PastSessions
